const flexGrow = {
    name: "flex-grow",
    path: "/flex-grow",
    title: "flex-grow",
    description: "Utilities for controlling how flex items both grow and shrink.",
    value: {
        "flex-grow": {
          'grow': "1",
          "grow-<number>":"<number>",
          "grow-[<value>]": "<value>",
        },
    },
    exampleData: [
        {
            "example": {
                "code": `
<div class="flex ...">
  <div class="size-14 flex-none ...">01</div>
  <div class="size-14 grow ...">02</div>
  <div class="size-14 flex-none ...">03</div>
</div>
                `
            },
        },
        {
            "example": {
                "code": `
<div class="flex ...">
  <div class="size-14 grow-3 ...">01</div>
  <div class="size-14 grow-7 ...">02</div>
  <div class="size-14 grow-3 ...">03</div>
</div>
                `
            },
        },
        {
            "example": {
                "code": `
<div class="flex ...">
  <div class="size-14 grow ...">01</div>
  <div class="size-14 grow-0 ...">02</div>
  <div class="size-14 grow ...">03</div>
</div>
                `
            },
        }
    ],
    htmlData: [
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">grow </code>
                 to allow a flex item to grow to fill any available space:
            </p>

            <div class="relative">
                <div class="absolute inset-0 z-0">
                    <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                </div>
                <div class="flex gap-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                    <div class="flex size-14 flex-none items-center justify-center rounded-lg bg-color-pink-300 p-4 dark:bg-color-pink-800 dark:text-color-pink-400">01</div>
                    <div class="flex size-14 grow items-center justify-center rounded-lg bg-color-pink-500 p-4">02</div>
                    <div class="flex size-14 flex-none items-center justify-center rounded-lg bg-color-pink-300 p-4 dark:bg-color-pink-800 dark:text-color-pink-400">03</div>
                </div>
            </div>

            
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">grow-<var>&lt;number&gt;</var></code>
                   utilities like grow-3 to make flex items grow proportionally based on their growth factor, allowing them to fill the available space relative to each other:
            </p>

             <div class="relative">
                <div class="absolute inset-0 z-0">
                    <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                </div>
                <div class="flex gap-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                    <div class="flex size-14 grow-3 items-center justify-center rounded-lg bg-color-pink-300 p-4 dark:bg-color-pink-800 dark:text-color-pink-400">01</div>
                    <div class="flex size-14 grow-7 items-center justify-center rounded-lg bg-color-pink-500 p-4">02</div>
                    <div class="flex size-14 grow-3 items-center justify-center rounded-lg bg-color-pink-300 p-4 dark:bg-color-pink-800 dark:text-color-pink-400">03</div>
                </div>
            </div>
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">grow-0</code>
                  to prevent a flex item from growing:
            </p>

             <div class="relative">
                <div class="absolute inset-0 z-0">
                    <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                </div>
                <div class="flex gap-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                    <div class="flex size-14 grow items-center justify-center rounded-lg bg-color-pink-300 p-4 dark:bg-color-pink-800 dark:text-color-pink-400">01</div>
                    <div class="flex size-14 grow-0 items-center justify-center rounded-lg bg-color-pink-500 p-4">02</div>
                    <div class="flex size-14 grow items-center justify-center rounded-lg bg-color-pink-300 p-4 dark:bg-color-pink-800 dark:text-color-pink-400">03</div>
                </div>
            </div>
        
            `
        }
    ]
};

export default flexGrow;

<div className="sr-only">

<div class="relative">
                <div class="absolute inset-0 z-0">
                    <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                </div>
                <div class="flex gap-4 font-mono text-sm leading-6 font-bold text-color-white relative">
                    <div class="flex size-14 flex-none items-center justify-center rounded-lg bg-color-pink-300 p-4 dark:bg-color-pink-800 dark:text-color-pink-400">01</div>
                    <div class="flex size-14 grow items-center justify-center rounded-lg bg-color-pink-500 p-4">02</div>
                    <div class="flex size-14 flex-none items-center justify-center rounded-lg bg-color-pink-500 p-4">03</div>
                </div>
                                    <div class="flex size-14 grow-3 items-center justify-center rounded-lg bg-color-pink-300 p-4 dark:bg-color-pink-800 dark:text-color-pink-400">01</div>
                    <div class="flex size-14 grow-7 items-center justify-center rounded-lg bg-color-pink-500 p-4">02</div>
                    <div class="flex size-14 grow-3 items-center justify-center rounded-lg bg-color-pink-300 p-4 dark:bg-color-pink-800 dark:text-color-pink-400">03</div>

            </div>

</div>